import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Button, Modal } from '@wf/components';

import FileUploader from '../../../../components/FileUploader';

import { type FileType } from '../../../../constants';

interface IImportModalProps {
  title: string;
  onCancel: () => void;
  onConfirm: (file: File) => void;
  isImportLoading: boolean;
  supportedFileTypes: FileType[];
  supportedMaxFileSizeInMB?: number;
}

function ImportModal({
  title,
  onConfirm,
  onCancel,
  isImportLoading,
  supportedFileTypes,
  supportedMaxFileSizeInMB = 2,
}: IImportModalProps) {
  const { t } = useTranslation();

  const [file, setFile] = useState<File | null>(null);

  const handleUpload = (file: File) => {
    setFile(file);
  };

  const handleDeleteFile = () => {
    setFile(null);
  };

  const handleConfirm = () => {
    onConfirm(file!);
  };

  return (
    <Modal handleClose={onCancel} id="import-items-modal" isOpen>
      <Modal.Header>
        <Modal.Title>{t(title)}</Modal.Title>
      </Modal.Header>
      <Modal.Content>
        <FileUploader
          supportedMaxFileSizeInMB={supportedMaxFileSizeInMB}
          supportedFileTypes={supportedFileTypes}
          onDeleteFile={handleDeleteFile}
          onUpload={handleUpload}
        />
      </Modal.Content>
      <Modal.Footer>
        <Button onClick={onCancel} color="typography" secondary>
          {t('Cancel')}
        </Button>
        <Button isLoading={isImportLoading} onClick={handleConfirm} disabled={!file}>
          {t('Upload')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ImportModal;
